export default {
  optSuccess: {
    icon: 'alert-icon-checked',
    backgroundColor: '#68B814',
    onClosed: function (instance, toast, closedBy) {}
  },
  optInfo: {
    icon: 'alert-icon-info',
    backgroundColor: '#00A4D6',
    onClosed: function (instance, toast, closedBy) {}
  },
  optWaring: {
    icon: 'alert-icon-warning',
    backgroundColor: '#FFA71B',
    onClosed: function (instance, toast, closedBy) {}
  },
  optError: {
    icon: 'alert-icon-error',
    backgroundColor: '#FF3400',
    onClosed: function (instance, toast, closedBy) {}
  }
};



// WEBPACK FOOTER //
// ./src/utils/izi-toast.js